import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Package, ChevronRight } from 'lucide-react';

export default function FeaturedVehicles({ vehicles }) {
  return (
    <section className="py-20 lg:py-28" style={{ background: 'var(--bg-surface)' }} data-testid="vehicles-section">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <span className="section-label">Notre Parc Auto</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mt-3 mb-4 tracking-tight">
            Véhicules Disponibles
          </h2>
          <p className="text-zinc-500 max-w-lg">
            Chaque véhicule est contrôlé, révisé et garanti pour votre tranquillité.
          </p>
        </motion.div>

        {vehicles.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {vehicles.map((vehicle, index) => (
              <motion.div
                key={vehicle.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className={`vehicle-card group ${vehicle.status === 'vendu' ? 'opacity-60' : ''}`}
                data-testid={`vehicle-card-${vehicle.id}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={vehicle.images?.[0] || 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=400'}
                    alt={`${vehicle.title} - Véhicule d'occasion à vendre à Quarouble`}
                    className="vehicle-image"
                  />
                  {vehicle.status === 'vendu' ? (
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                      <span className="bg-red-600 text-white text-lg font-black px-6 py-2 uppercase tracking-widest transform -rotate-6">
                        VENDU
                      </span>
                    </div>
                  ) : (
                    <span className="absolute top-3 right-3 price-badge text-sm">
                      {vehicle.price.toLocaleString('fr-FR')} €
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-bold text-white mb-1">{vehicle.title}</h3>
                  <p className="text-zinc-500 text-xs mb-3" style={{ fontFamily: 'var(--font-mono)' }}>
                    {vehicle.brand} {vehicle.model}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className="badge">{vehicle.year}</span>
                    <span className="badge">{vehicle.mileage.toLocaleString('fr-FR')} km</span>
                    <span className="badge">{vehicle.fuel}</span>
                    <span className="badge">{vehicle.transmission}</span>
                  </div>
                  {vehicle.status === 'vendu' ? (
                    <span className="block w-full text-center py-2.5 text-xs text-zinc-600 border border-white/5">
                      Ce véhicule a été vendu
                    </span>
                  ) : (
                    <Link to={`/vehicules/${vehicle.id}`} className="block w-full text-center py-2.5 bg-[#DC2626] text-white text-sm font-semibold transition-all duration-200 hover:bg-[#B91C1C]">
                      Voir le véhicule
                    </Link>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 border border-white/5" style={{ background: 'var(--bg-elevated)' }}>
            <Package className="mx-auto text-zinc-600 mb-4" size={48} />
            <p className="text-zinc-500 mb-4">Aucun véhicule disponible pour le moment</p>
            <Link to="/contact" className="text-[#DC2626] font-semibold hover:underline">
              Contactez-nous pour vos recherches
            </Link>
          </div>
        )}

        <div className="mt-10">
          <Link
            to="/vehicules"
            className="group inline-flex items-center gap-2 px-7 py-4 bg-[#DC2626] text-white font-semibold text-sm tracking-wide transition-all duration-200 hover:bg-[#B91C1C]"
          >
            Voir tous les véhicules
            <ChevronRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
